import { useMemo } from "react";
import { UseMutateFunction } from "react-query";
import {
  useGetRequest,
  QueriesTypes,
  usePostRequest,
  useDeleteRequest,
  usePutRequest,
} from "../../../../common/hooks/queries";
import { Proposta } from "../propostas.types";

export const useGetPropostaById = (
  id: string | undefined
): [Proposta, boolean, boolean] => {
  const {
    data: propostaData,
    isError,
    isLoading,
  } = useGetRequest(QueriesTypes.Propostas, id);

  const proposta: Proposta = useMemo(() => {
    if (propostaData && !isError) {
      return { ...propostaData, createdAt: new Date(propostaData.createdAt) };
    } else {
      return {} as Proposta;
    }
  }, [propostaData, isError, id]);

  return [proposta, isLoading, isError];
};

export const useAddCadastroToProposta = (
  finishCallback: () => void
): [
  UseMutateFunction<
    any,
    unknown,
    {
      requestPayload: {
        [key: string]: any;
      };
      queryParams?:
        | {
            clientId?: string | number;
            step?: number;
          }
        | undefined;
    }
  >,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = usePostRequest(
    QueriesTypes.CadastroInProposta,
    { onSettledCallback: finishCallback }
  );

  return [mutate, isLoading, isError];
};

export const useAddServicoValorToProposta = (
  finishCallback: () => void
): [
  UseMutateFunction<
    any,
    unknown,
    {
      requestPayload: {
        [key: string]: any;
      };
      queryParams?:
        | {
            clientId?: string | number;
            step?: number;
          }
        | undefined;
    }
  >,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = usePostRequest(
    QueriesTypes.ServicoInProposta,
    { onSettledCallback: finishCallback }
  );

  return [mutate, isLoading, isError];
};

export const useDeleteServicoValorInProposta = (
  finishCallback: () => void
): [
  UseMutateFunction<
    any,
    unknown,
    {
      id?: string | number;
      nome?: string;
      clienteId?: number;
      servicoInPropostaQuery?: string;
    }
  >,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = useDeleteRequest(
    QueriesTypes.ServicoInProposta,
    { onSettledCallback: finishCallback }
  );

  return [mutate, isLoading, isError];
};

export const useUpdateServicoValorInProposta = (
  callback: () => void
): [UseMutateFunction<any, unknown, any>, boolean, boolean] => {
  const { isLoading, isError, mutate } = usePutRequest(
    QueriesTypes.ServicoInProposta,
    { onSettledCallback: callback }
  );

  return [mutate, isLoading, isError];
};

export const useUpdateCadastroValorInProposta = (
  callback: () => void
): [UseMutateFunction<any, unknown, any>, boolean, boolean] => {
  const { isLoading, isError, mutate } = usePutRequest(
    QueriesTypes.CadastroInProposta,
    { onSettledCallback: callback }
  );

  return [mutate, isLoading, isError];
};

export const useDeleteCadastroValorInProposta = (
  finishCallback: () => void
): [
  UseMutateFunction<
    any,
    unknown,
    {
      id?: string | number;
      nome?: string;
      clienteId?: number;
      cadastroInPropostaQuery?: string;
    }
  >,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = useDeleteRequest(
    QueriesTypes.CadastroInProposta,
    { onSettledCallback: finishCallback }
  );

  return [mutate, isLoading, isError];
};

export const useAddAnexoToProposta = (
  finishCallback: () => void
): [
  UseMutateFunction<
    any,
    unknown,
    {
      requestPayload: {
        [key: string]: any;
      };
    }
  >,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = usePostRequest(
    QueriesTypes.PropostasAnexos,
    { onSettledCallback: finishCallback }
  );

  return [mutate, isLoading, isError];
};

export const useDeleteAnexoInProposta = (
  finishCallback: () => void
): [
  UseMutateFunction<
    any,
    unknown,
    {
      id?: string | number;
      nome?: string;
      clienteId?: number;
    }
  >,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = useDeleteRequest(
    QueriesTypes.PropostasAnexos,
    { onSettledCallback: finishCallback }
  );

  return [mutate, isLoading, isError];
};
